<template>
  <!-- star -->

  <div class="youjiaopage_wrap">
    <banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>当前位置：首页>智能设备><span>设备详情</span></div>
    </div>
    <!-- 招聘信息 -->
    <div class="Recruitment">
        <div class="Recruitment_cont">
            <!-- 产品详情 -->
            <div class="product-text-content">
              <!-- 图片放大功能 -->
              <s-imgZoom :width="550" :height="550" :minIMGsrc="require('@/assets/index/sb_mccb.png')" :scale="3" />

              <div class="product-text-js">
                  <div class="title">
                    <h3>智能塑壳</h3>
                  </div>
                  <p class="text">控制系统由西门子或AB公司原装PLC为控制核心，配置高清触摸屏，可控制永磁电机、变频器、水冷电机及散热风机的启动/停止(水冷电机需配置电磁启动器)。采集永磁电机、冷却装置温度信号，并与电机启动回路联锁，保证皮带机安全、可靠运行。控制箱预留以太网、RS485通讯接口，可与变频器、综合保护系统、皮带机主控系统、综合自动化系统进行数据传输。</p>
                  <div class="sparkle-text">
                    <span>产品亮点：</span>
                    <i>无线联网</i>
                    <i>智能监控</i>
                    <i>状态预警</i>
                    <i>信息通知</i>
                  </div>
                  <div class="phone-text">
                      <img src="" alt="" />
                      <span>产品咨询：</span>
                      <e>0791-88866416</e>
                  </div>
              </div>
            </div>
            
            <!-- 产品概况 -->
            <div class="product-overview">
                <div class="honor-tabs">
                    <ul class="honor-ul fx">
                        <li class="honor-li" @click="cur=0" :class="{'honor-active':cur==0}">产品概况</li>
                        <li class="honor-li" @click="cur=1" :class="{'honor-active':cur==1}">详细参数</li>
                    </ul>
                </div>
                <div class="elegant-center">
                  <div class="elegant-img" v-show="cur==0">
                      <div class="content-text-view">
                          <p>这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍这是产品介绍</p>
                          <img style="width: 100%; margin-top: 20px" src="@/assets/img/news_img1.png" alt="" />
                      </div>
                  </div>
                  <div class="@/assets/index/elegant-img" v-show="cur==1">
                    456
                  </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 翻页 -->

    <!-- end -->
  </div>
</template>


<script>
import sImgZoom from "../components/s-imgZoom.vue";
import banner2 from "../components/banner.vue";
export default {
  name: "productDetails",
  components: {
    sImgZoom,
    banner2,
  },
  data() {
    return {
      h1: "智能设备",
      Img1: require("../assets/img/keji/cp_banner.png"),
      p1: "更多最新精彩资讯，感受企业魅力",
      cur: 0,
    };
  },
  methods: {
    
  },
};
</script>
<style scoped>
@import "../assets/css/recruit-info.css";
.product-text-content{
  display: -webkit-flex;
  display: flex;
}
.product-text-js{
  width: 100%;
  margin-left: auto;
  padding-top: 0px;
  padding-bottom: 30px;
  padding-left: 50px;
  padding-right: 0px;
}
.product-text-js .title{
    padding-bottom: 15px;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-bottom-color: rgba(51,51,51,1);
    margin-bottom: 25px;
}
.product-text-js .title h3{
  line-height: 1.8;
  font-size: 30px;
  font-weight: bold;
  color: #333333;
}
.product-text-js .text{
  font-size: 14px;
  color: #666666;
  line-height: 1.8;
  margin-top: 10px;
  margin-bottom: 20px;
}
.sparkle-text{
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;
}
.sparkle-text span{
  line-height: 2.5;
  font-size: 14px;
  color: #888888;
  font-weight: bold;
}
.sparkle-text i{
  background: rgba(111,249,197,0.10);
  border: 1px solid #4CCE9D;
  margin-right: 15px;
  padding: 5px 10px;
  color: #16b97c;
  border-radius: 3px
}
.phone-text{
  padding-top: 20px;
  padding-bottom: 20px;
  border-top-style: dashed;
  border-top-width: 1px;
  border-top-color: rgba(221,221,221,1);
  border-bottom-style: dashed;
  border-bottom-width: 1px;
  border-bottom-color: rgba(221,221,221,1);
  line-height: 40px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.phone-text span{
  font-size: 18px;
  color: #212529;
  font-weight: bold;
}
.phone-text e{
  font-size: 26px;
  font-weight: normal;
  font-family: Impact;
  color: rgba(229,0,18,1);
}
.product-overview{
  width: 100%;
  display: block;
  margin-top: 36px;
}
.product-overview .honor-tabs .honor-ul{
  margin-bottom: 0px;
}
.product-overview .honor-tabs .honor-ul li{
    font-size: 18px;
    line-height: 56px;
    position: relative;
}
.product-overview .honor-tabs .honor-ul li::after{
  display: none;
}
.product-overview .honor-tabs .honor-ul li.honor-active{
  color: #4CCE9D;
} 
.product-overview .honor-tabs .honor-ul li.honor-active::before{
  content: '';
  width: 72px;
  height: 4px;
  position: absolute;
  left: 0;
  bottom: -1px;
  background: #4CCE9D;
}
.product-overview .honor-tabs{
    width: 100%;
    border-bottom: 2px solid #eeeff0;
}
.product-overview .elegant-center{
  margin: 20px 0;
}
.content-text-view p{
  font-size: 14px;
  line-height: 25px;
}
</style>


